export const SELECT_BENTUK_KERJASAMA = "@bentukKerjasama/SELECT_USER";

export const INITIALIZE_CREATE_BENTUK_KERJASAMA = "@bentukKerjasama/INITIALIZE_CREATE_BENTUK_KERJASAMA";

export const UPDATE_NAME = "@bentukKerjasama/UPDATE_NAME";
export const UPDATE_STATUS = "@bentukKerjasama/UPDATE_STATUS";

export const GET_BENTUK_KERJASAMA_REQUEST = "@bentukKerjasama/GET_BENTUK_KERJASAMA_REQUEST";
export const GET_BENTUK_KERJASAMA_SUCCESS = "@bentukKerjasama/GET_BENTUK_KERJASAMA_SUCCESS";
export const GET_BENTUK_KERJASAMA_FAILURE = "@bentukKerjasama/GET_BENTUK_KERJASAMA_FAILURE";

export const GET_DETAIL_BENTUK_KERJASAMA_REQUEST = "@bentukKerjasama/GET_DETAIL_BENTUK_KERJASAMA_REQUEST";
export const GET_DETAIL_BENTUK_KERJASAMA_SUCCESS = "@bentukKerjasama/GET_DETAIL_BENTUK_KERJASAMA_SUCCESS";
export const GET_DETAIL_BENTUK_KERJASAMA_FAILURE = "@bentukKerjasama/GET_DETAIL_BENTUK_KERJASAMA_FAILURE";

export const UPDATE_BENTUK_KERJASAMA_REQUEST = "@bentukKerjasama/UPDATE_BENTUK_KERJASAMA_REQUEST";
export const UPDATE_BENTUK_KERJASAMA_SUCCESS = "@bentukKerjasama/UPDATE_BENTUK_KERJASAMA_SUCCESS";
export const UPDATE_BENTUK_KERJASAMA_FAILURE = "@bentukKerjasama/UPDATE_BENTUK_KERJASAMA_FAILURE";

export const CREATE_BENTUK_KERJASAMA_REQUEST = "@bentukKerjasama/CREATE_BENTUK_KERJASAMA_REQUEST";
export const CREATE_BENTUK_KERJASAMA_SUCCESS = "@bentukKerjasama/CREATE_BENTUK_KERJASAMA_SUCCESS";
export const CREATE_BENTUK_KERJASAMA_FAILURE = "@bentukKerjasama/CREATE_BENTUK_KERJASAMA_FAILURE";